import React  from "react";
import Banner from "./Banner";
import DataContent from "./DataContent";
import { Helmet } from "react-helmet";
import Howitwork from "./Howitwork";
import Servicedata from "./Servicedata";
import  { useBannerdata, useContentdata, usePagemetaTags} from "../FetchAPI";


export default function Services() {

  const [bannerdata] = useBannerdata();
  const [contentdata] = useContentdata();
  const [PagemetaTags] = usePagemetaTags();


  return (
    <>
      <Helmet>
        <title>{PagemetaTags.ServiceMetatitle}</title>
        <meta name="keywords" content={PagemetaTags.ServiceMetaKeyword} />
        <meta name="description" content={PagemetaTags.ServiceMetaDesc} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Banner
        Bnanerimage={bannerdata.service_banner}
        image_title={bannerdata.service_banner_title}
        image_alt={bannerdata.service_banner_alt}
      />
      {/* Services Section Start */}
  <Servicedata/>
      {/* Services Section End */}

      {/* Content-3 Section Start */}
      {contentdata.title6 && (
        <DataContent
          title={contentdata.title6}
          desc={contentdata.description6}
        />
      )}

      {/* Content-3  Section End */}

      {/* How Work Section Start */}
     <Howitwork/>
      {/* How Work Section End */}
    </>
  );
}
